import { AutogenModelRateHeader, AutogenRowRateHeader } from "./autogen/AutogenModelRateHeader";

export class ModelRateHeader extends AutogenModelRateHeader<RowRateHeader> {
	constructor() {
		super(RowRateHeader);
	}
}

export class RowRateHeader extends AutogenRowRateHeader {
}